import { toLinkWithHint } from '@news-mono/web-common'

import React from 'react'

import { CardMedia } from '../../CardMedia/CardMedia'
import { BaseCardProps } from '../Card'
import { ArticleCardContainer, Headline } from './ArticleCard.styled'
import { CardBodyWrapper, Teaser, ReadMore } from '../components'
import { TheNightlyByline } from '../../../publication/Byline/TheNightlyByline'

export interface ArticleCardProps extends BaseCardProps<'article-card'> {}

export const ArticleCard = ({
    item,
    onEvent,
}: Omit<ArticleCardProps, 'kind'>) => {
    const { loaded: isLoading } = item
    const result = isLoading ? item.result : undefined

    return (
        <ArticleCardContainer to={toLinkWithHint(item)}>
            <CardBodyWrapper>
                <TheNightlyByline
                    profile={result?.profiles}
                    text={result?.byline}
                    topic={result?.primaryTopic.title}
                    timestamp={result?.publicationDate}
                    isFullWidth
                    isLink={false}
                />
            </CardBodyWrapper>
            <CardMedia
                imageWidths={{
                    desktop: '100%',
                    tablet: '100%',
                    mobile: '100%',
                    fallbackWidth: 70,
                }}
                item={item}
                onEvent={onEvent}
                disableImageLazyLoad
                mediaMode={'fullHeight'}
            />
            {result && (
                <CardBodyWrapper>
                    <Headline>{result.shortHeadline}</Headline>
                    <Teaser>{result.teaser}</Teaser>
                    <ReadMore readTime={result.readTimeMinutes} />
                </CardBodyWrapper>
            )}
        </ArticleCardContainer>
    )
}
